import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import OrderService from "services/OrderService";

export const getOrders = createAsyncThunk(
  "order/getOrders",
  async (params, { rejectWithValue }) => {
    try {
      const response = await OrderService.getOrders(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getPaymentStatus = createAsyncThunk(
  "order/getPaymentStatus",
  async (params, { rejectWithValue }) => {
    try {
      const response = await OrderService.getPaymentStatus(params);
      console.log(response);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const updateOrderStatus = createAsyncThunk(
  "order/updateOrderStatus",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await OrderService.updateOrderStatus(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const updateRefundStatus = createAsyncThunk(
  "order/updateRefundStatus",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await OrderService.updateRefundStatus(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getOrderNotes = createAsyncThunk(
  "order/getOrderNotes",
  async (params, { rejectWithValue }) => {
    try {
      const response = await OrderService.getOrderNotes(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const addOrderNotes = createAsyncThunk(
  "order/addOrderNotes",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await OrderService.addOrderNotes(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadOrderExcel = createAsyncThunk(
  "user/downloadOrderExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await OrderService.downalodOrderExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSingleOrder = createAsyncThunk(
  "order/getSingleOrder",
  async (params, { rejectWithValue }) => {
    try {
      const response = await OrderService.getSingleOrder(params);
      console.log(response);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editBulkOrderStatus = createAsyncThunk(
  "order/editBulkOrderStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await OrderService.updateOrderBulkStatus(data, status);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

export const getBulkOrdersForInvoice = createAsyncThunk(
  "order/getBulkOrdersForInvoice",
  async (orderIds, { rejectWithValue }) => {
    try {
      const res = await OrderService.bulkInvoiceDetails(orderIds);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch bulk order invoice data"
      );
    }
  }
);

const orderSlice = createSlice({
  name: "orders",
  initialState: {
    orders: {},
    singleOrder: {},
    myStudents: {},
    loading: false,
    error: null,
    orderNotes: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addOrderNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addOrderNotes.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addOrderNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOrderNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrderNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.orderNotes = action.payload;
      })
      .addCase(getOrderNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPaymentStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getPaymentStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadOrderExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadOrderExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadOrderExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getSingleOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.singleOrder = action.payload.data;
      })
      .addCase(getSingleOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateOrderStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editBulkOrderStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editBulkOrderStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editBulkOrderStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getBulkOrdersForInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBulkOrdersForInvoice.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getBulkOrdersForInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const {} = orderSlice.actions;
export default orderSlice.reducer;
